import React, { useEffect, useState } from 'react';
import { Grid, Typography, Paper, useMediaQuery, useTheme } from '@mui/material';
import { getTopics } from './Api';
import { Box } from '@mui/system';

export default function Topics({ 
  chapters,
  setSelectedChapter,
  setSelectedAyatNumber,
  navMenuItemClick,
  setViewType}) {
  const [groupedTopics, setGroupedTopics] = useState({});
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    getTopics()
      .then((data) => {
        const topics = data.topics;

        // Group by first letter
        const grouped = topics.reduce((acc, topic) => {
          const firstChar = (topic.topicTitle || '#')[0].toUpperCase();
          if (!acc[firstChar]) acc[firstChar] = [];
          acc[firstChar].push(topic);
          return acc;
        }, {});

        setGroupedTopics(grouped);
      })
      .catch((error) => console.error('❌ Error loading topics:', error));
  }, []);

  const sortedKeys = Object.keys(groupedTopics).sort();

  const getChapterById = (chapterId) =>
    chapters.find((chapter) => chapter.id == chapterId);

  const handleTopicClick = (topic) => {
    
    const chapter = getChapterById(topic.chapterId);
    if (!chapter) return;

    setSelectedChapter(chapter);

    setSelectedAyatNumber(topic.firstAyatNumber);
    navMenuItemClick("read");
  };

  return (
    <Box mt={12} sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
      <div style={{ padding: '1rem', width: '100%' }}>
        {/* Alphabet Navigation */}
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 1,
            mb: 3,
            justifyContent: 'center',
          }}
        >
          {sortedKeys.map((letter) => (
            <Typography
              key={letter}
              variant="default_body"
              sx={{
                cursor: 'pointer',
                px: 1,
           
                textDecoration: 'underline',
              }}
              onClick={() => {
                const section = document.getElementById(`letter-${letter}`);
                if (section) {
                  section.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
              }}
            >
             <b>{letter}</b> 
            </Typography>
          ))}
        </Box>
  
        {/* Topics Grouped by Letter */}
        {sortedKeys.map((letter) => (
          <div key={letter} id={`letter-${letter}`}>
            <Typography variant="appBarTitle" style={{ marginTop: '1.5rem', marginBottom: '0.5rem' }}>
              {letter}
            </Typography>
  
            <Grid container spacing={2}>
              {groupedTopics[letter].map((topic) => (
                <Grid
                  item
                  key={topic.topicId}
                  xs={12}
                  sm={isSmallScreen ? 12 : 6}
                  md={4}
                  lg={3}
                >
                  <Box
                    sx={{ p: 2, cursor: 'pointer' }}
                    onClick={() => handleTopicClick(topic)}
                  >
                    <Typography variant="default_body">
                      {topic.topicTitle} [{topic.chapterNumber}:{topic.firstAyatNumber}]
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </div>
        ))}
      </div>
    </Box>
  );
  
}
